/* Selet v96 (02/10): carrosséis leves da home (sections/selet-products-light.liquid).
   1) Vitrine: CSS scroll-snap; aqui só setas (computador), bolinhas de posição e estado das setas.
   2) Card: só a 1ª foto vem no HTML; as outras (até 4) vêm de /products/<handle>.js na 1ª interação com o card. */
(function () {
  if (window.__seletPL) return; window.__seletPL = 1;

  function initCar(root) {
    if (root.__ok) return; root.__ok = 1;
    var t = root.querySelector('.spl-track'); if (!t) return;
    var prev = root.querySelector('.spl-prev'), next = root.querySelector('.spl-next'), dots = root.querySelector('.spl-dots');
    var raf = 0, nd = -1;
    function cardW() { var c = t.firstElementChild; if (!c) return t.clientWidth; var g = parseFloat(getComputedStyle(t).columnGap) || 0; return c.getBoundingClientRect().width + g; }
    function step() { var w = cardW(); var per = Math.max(1, Math.floor((t.clientWidth + 2) / w)); return per * w; }
    function pages() { var max = t.scrollWidth - t.clientWidth; return max <= 2 ? 1 : Math.ceil(max / step() - 0.05) + 1; }
    function cur() { var max = t.scrollWidth - t.clientWidth; if (t.scrollLeft >= max - 2) return pages() - 1; return Math.round(t.scrollLeft / step()); }
    function buildDots() {
      if (!dots) return; var n = pages(); if (n === nd) return; nd = n; dots.innerHTML = '';
      if (n < 2) return;
      for (var i = 0; i < n; i++) { var b = document.createElement('button'); b.type = 'button'; b.className = 'swiper-pagination-bullet spl-dot'; b.setAttribute('aria-label', 'Ir para ' + (i + 1)); (function (k) { b.addEventListener('click', function () { go(k); }); })(i); dots.appendChild(b); }
    }
    function go(k) { var max = t.scrollWidth - t.clientWidth; t.scrollTo({ left: Math.max(0, Math.min(max, k * step())), behavior: 'smooth' }); }
    function arrowsPos() {
      var img = t.querySelector('.product-item__inner'); if (!img || !prev) return;
      var top = img.getBoundingClientRect().top - root.getBoundingClientRect().top + img.offsetHeight / 2 - 25;
      prev.style.top = next.style.top = top + 'px';
    }
    function upd() {
      raf = 0; buildDots(); var i = cur(), max = t.scrollWidth - t.clientWidth;
      if (dots) for (var k = 0; k < dots.children.length; k++) dots.children[k].classList.toggle('swiper-pagination-bullet-active', k === i);
      if (prev) { prev.disabled = t.scrollLeft <= 2; next.disabled = t.scrollLeft >= max - 2; }
    }
    function q() { if (!raf) raf = requestAnimationFrame(upd); }
    t.addEventListener('scroll', q, { passive: true });
    window.addEventListener('resize', function () { nd = -1; arrowsPos(); q(); });
    if (prev) {
      prev.addEventListener('click', function () { t.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { t.scrollBy({ left: step(), behavior: 'smooth' }); });
    }
    arrowsPos(); upd();
  }

  /* Fotos extras do card, sob demanda */
  var widths = [165, 240, 330, 360, 480, 540, 600, 800];
  function wurl(src, w) { return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function hyd(sw) {
    if (!sw || sw.__h || !sw.dataset.handle) return; sw.__h = 1;
    var slides = sw.querySelectorAll('.selet-swipe__slide'); if (slides.length < 2) return;
    var first = slides[0].querySelector('img'); var sizes = first ? first.getAttribute('sizes') : '';
    fetch('/products/' + sw.dataset.handle + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
      if (!p) return; var ims = (p.media || []).filter(function (m) { return m.media_type === 'image'; });
      for (var i = 1; i < slides.length && i < ims.length; i++) {
        if (slides[i].querySelector('img')) continue;
        var m = ims[i], src = (m.src || '').replace(/^https?:/, ''), im = document.createElement('img');
        im.alt = m.alt || p.title || ''; im.width = 600; im.height = 600; im.loading = i === 1 ? 'eager' : 'lazy'; im.decoding = 'async';
        im.sizes = sizes; im.srcset = widths.map(function (w) { return wurl(src, w) + ' ' + w + 'w'; }).join(', '); im.src = wurl(src, 540);
        slides[i].appendChild(im); slides[i].removeAttribute('tabindex');
      }
    }).catch(function () { sw.__h = 0; });
  }
  function fromEv(e) {
    var t = e.target; if (!t || !t.closest) return;
    var c = t.closest('.spl-card'); if (!c) return;
    hyd(c.querySelector('.selet-swipe[data-handle]'));
  }
  ['touchstart', 'pointerdown', 'mouseover', 'focusin'].forEach(function (ev) { document.addEventListener(ev, fromEv, { capture: true, passive: true }); });
  document.addEventListener('scroll', function (e) { var t = e.target; if (t && t.classList && t.classList.contains('selet-swipe__track')) hyd(t.parentNode); }, true);

  function boot() { document.querySelectorAll('[data-spl]').forEach(initCar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
